import React from 'react';
import intl from 'react-intl-universal';
import { withRouter } from 'react-router-dom';
import AuthStore from '../stores/AuthStore';
import StateStore from '../stores/StateStore';
import CodeActions from '../actions/CodeActions';
import CodeStore from '../stores/CodeStore';

class ProductSuggestionsComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      codes: [],
      config: AuthStore.getConfig(),
      pack: StateStore.getPack()
    }
    this.onChange = this.onChange.bind(this);
    this.codeClick = this.codeClick.bind(this);
    this.getCodeElements = this.getCodeElements.bind(this);
  }

  getCodeElements(){
    const {codes} = this.state
    if((codes.bundles && codes.bundles.length>0) || (codes.products && codes.products.length>0)){
      return (
        <div className="product_suggestions_columns">
          <div className="sug_col sug_col1">
            <h5>{intl.get('zestawy')}</h5>
            <div className="sug_col_tags">
              {codes.bundles.map((code, index) => (
                <span className={code.length>23?'long':''} onClick={this.codeClick} key={index}>{code}</span>
              ))}
            </div>
          </div>
          <div className="sug_col sug_col2">
            <h5>{intl.get('produkty')}</h5>
            <div className="sug_col_tags">
              {codes.products.map((code, index) => (
                <span className={code.length>23?'long':''} onClick={this.codeClick} key={index}>{code}</span>
              ))}
            </div>
          </div>
        </div>
      )
    } else if (codes.length>0) {
      return codes.map((code, index) => (
        <span onClick={this.codeClick} key={index}>{code}</span>
      ))
    }
  }

  componentWillMount() {
    CodeStore.addChangeListener(this.onChange);
  }

  componentDidMount() {
    CodeActions.search(this.state.pack, '')
  }

  componentWillUnmount() {
    CodeStore.removeChangeListener(this.onChange);
  }

  onChange() {
    this.setState({
      codes: CodeStore.getCodes()
    });
  }
  codeClick(e) {
    const {parent} = this.props
    let txt = document.createElement('textarea')
    txt.innerHTML = e.target.innerHTML
    parent.setState({
      kod: txt.value
    })
  }

  render() {
    return (
      <div className={'ramka center product_suggestions'+(this.props.visible?'':' d-none')}>
        { this.state.config.no_packages &&
          <h4>{intl.get('Kody produktów')}</h4>
        }
        { !this.state.config.no_packages &&
          <h4>{intl.get('Kody produktów w paczce')}</h4>
        }
        {this.getCodeElements()}
      </div>
    );
  }
}

export default withRouter(ProductSuggestionsComponent);



// WEBPACK FOOTER //
// ./src/components/ProductSuggestions.js